/*
     Title: LINe API
     Description: LINe API
     Author: Iqbal Hossain
     Date: 06-January-2022
     Modified: 06-January-2022
*/

export const LINE_API = {
  root: '/api/line',
  fetch_all: 'api/line/fetch-all',
  fetch_by_query: `/api/line/fetch-by-query`,
  fetch_by_id: `/api/line/fetch-by-id`,
  add: `/api/line/add`,
  update: `/api/line/update`,
  delete: `/api/line/delete`,
  delete_by_range: `/api/line/delete-range`
};

/** Change Log
 * 08-Jan-2022(Iqbal): Create (root, fetch_by_query, fetch_by_id, add, update, delete, delete_by_range )
 */
